import { NgModule } from '@angular/core';
import { AegButtonModule } from './button/util/aeg-button-api';

@NgModule({
  imports: [
    AegButtonModule
  ],
  exports: [
    AegButtonModule
  ]
})
export class ComponentsModule {
}